import React from 'react';
import _ from 'lodash';
import ReactDragListView from 'react-drag-listview';

import styles from './CategoryList.module.css';
import CategoryItem from './CategoryItem';

const CategoryList = ({
  categories,
  campaignId,
  isUpdating,
  updateCategories,
}) => {
  const handleUpdateCategories = (updatedCategories, parentId) => {
    updateCategories(campaignId, updatedCategories, parentId, categories);
  };
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...categories];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      handleUpdateCategories(data);
    },
    nodeSelector: '.categories>li',
    handleSelector: !isUpdating && '.categories .reorder-button',
    lineClassName: 'react-drag-line',
  };

  return (
    <ReactDragListView {...dragProps}>
      <ul className={`categories ${styles.categoryList}`}>
        {_.map(categories, (category) => {
          const { id, name, productsCount, children } = category;
          return (
            <CategoryItem
              key={id}
              id={id}
              name={name}
              productsCount={productsCount}
              subcategories={children}
              isUpdating={isUpdating}
              updateCategories={handleUpdateCategories}
            />
          );
        })}
      </ul>
    </ReactDragListView>
  );
};

export default CategoryList;
